import { render, staticRenderFns } from "./RectangleFab.vue?vue&type=template&id=5f5d1d6c&lang=pug&"
import script from "./RectangleFab.vue?vue&type=script&lang=js&"
export * from "./RectangleFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RectangleFab.vue"
export default component.exports